export default "__VITE_ASSET__CN2dnTS$__"